import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

interface Order {
  category_description: string;
  frequencyVal: string;
  id: number;
  name: string;
  orderCategory: string;
  orderName: string;
  orderType: number;
  prerequisiteOrder: string;
  response: string;
  routeUrgencyId: string;
  routeUrgencyVal: string;
  type: string;
  orderDay?: string;
  orderReturnTime?: string;
  reportTime?: string;
}

@Component({
  selector: 'app-location-orders-dialog',
  templateUrl: './location-orders-dialog.component.html',
  styleUrls: ['./location-orders-dialog.component.scss']
})
export class LocationOrdersDialogComponent implements OnChanges {
  @Input() selectedOrders: Order[] = [];
  @Input() newLocation: string = '';
  @Input() currentCaseTime: string = '';
  @Input() isOutpatientLocation: boolean = false;
  @Input() selectedSimulationTime: any = null;

  @Output() confirmMove = new EventEmitter<{appointmentTime?: string}>();
  @Output() cancelMove = new EventEmitter<void>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() openTimeSelection = new EventEmitter<void>();

  appointmentTime: string = 'Not scheduled';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedSimulationTime'] && this.selectedSimulationTime) {
      this.updateAppointmentTime(this.selectedSimulationTime);
    }
  }

  getUrgencyText(routeUrgencyId: string): string {
    return routeUrgencyId === '1' ? 'Stat' : 'Routine';
  }

  getReportTime(order: Order): string {
    if (order.orderDay && order.orderReturnTime) {
      const hours = order.orderReturnTime.substring(0, 2);
      const minutes = order.orderReturnTime.substring(2);
      return `Day ${order.orderDay} @ ${hours}:${minutes}`;
    }
    return order.reportTime || '-';
  }

  onScheduleAppointment(): void {
    this.openTimeSelection.emit();
  }

  private updateAppointmentTime(simulationTime: any): void {
    const hours = simulationTime.hours.toString().padStart(2, '0');
    const minutes = simulationTime.minutes.toString().padStart(2, '0');
    this.appointmentTime = `Day ${simulationTime.days} @ ${hours}:${minutes}`;
  }

  onConfirmMove(): void {
    this.confirmMove.emit({
      appointmentTime: this.selectedSimulationTime ? this.appointmentTime : undefined
    });
  }

  onCancelMove(): void {
    this.cancelMove.emit();
    this.closeDialog.emit();
  }
} 